export default {"src":"/_next/static/media/mist.3ed30194.svg","height":165,"width":165};